import { type CSSProperties, type PropsWithChildren, use } from "react";
import { Link, Route, Switch } from "wouter";
import { AuthContext, AuthProvider } from "./auth";
import { Dashboard } from "./dashboard";
import { InstanceIdContext, InstanceIdProvider, InstanceProvider } from "./instance";
import { Profile } from "./profile";
import { TestBox } from "./testbox";
import { UserList } from "./users";

export const App = () => {
  return (
    <TestBox>
      <InstanceIdProvider>
        <AuthProvider>
          <InstanceProvider>
            <Layout>
              <AppRouter />
            </Layout>
          </InstanceProvider>
        </AuthProvider>
      </InstanceIdProvider>
    </TestBox>
  );
};

const AppRouter = () => {
  const { instanceId } = use(InstanceIdContext);

  return (
    <Switch>
      <Route path={`/${instanceId}`} component={Dashboard} />
      <Route path={`/${instanceId}/profile`} component={Profile} />
      <Route path={`/${instanceId}/users`} component={UserList} />
    </Switch>
  );
};

const rootLayout: CSSProperties = {
  display: "grid",
  gridTemplateRows: "100px 1fr",
  marginLeft: "30px",
  marginRight: "30px",
};

const Layout = (props: PropsWithChildren) => {
  const { instanceId } = use(InstanceIdContext);
  const { firstName, lastName } = use(AuthContext);

  return (
    <div style={rootLayout}>
      <div className="navbar bg-base-100 shadow-sm">
        <div className="flex-none">
          <button type="button" className="btn btn-square btn-ghost">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <title>ToyBox</title>
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3.5 17.5c5.667 4.667 11.333 4.667 17 0" />
              <path d="M19 18.5l-2 -8.5l1 -2l2 1l1.5 -1.5l-2.5 -4.5c-5.052 .218 -5.99 3.133 -7 6h-6a3 3 0 0 0 -3 3" />
              <path d="M5 18.5l2 -9.5" />
              <path d="M8 20l2 -5h4l2 5" />
            </svg>
          </button>
        </div>
        <div className="flex-1">
          <Link className="btn btn-ghost text-xl" href={`/${instanceId}`}>
            ToyBox
          </Link>
        </div>
        <div className="flex-none">
          <ul className="menu menu-horizontal px-1">
            <li>
              <Link to={`/${instanceId}/users`} asChild>
                <button type="button" className="btn btn-ghost">
                  Users
                </button>
              </Link>
            </li>
            <li>
              <button
                type="button"
                className="btn btn-ghost"
                popoverTarget="popover-1"
                style={{ anchorName: "--anchor-1" } as CSSProperties}
              >
                Profile
              </button>
              <ul
                className="dropdown dropdown-end menu w-52 rounded-box bg-base-100 shadow-sm"
                popover="auto"
                id="popover-1"
                style={{ positionAnchor: "--anchor-1" } as CSSProperties}
              >
                <li>
                  <Link to={`/${instanceId}/profile`}>
                    {firstName} {lastName}
                  </Link>
                </li>
                <li>
                  <a href={`/api/logout/${instanceId}`}>Logout</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div>{props.children}</div>
    </div>
  );
};
